 
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { useLangContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { getContextBasedHeadline } from '../../lib/helpers';
import { useTranslationsContext } from '../../lib/translation';
import { useRegistrationContext } from '../../lib/context';

const SelfServiceFrontComponent: FC = () => {
  const translations = useTranslationsContext();
  const context = useRegistrationContext();
  const lang = useLangContext();

  return (
    <>
      <div className="page__content__block">
        <h1>
          {getContextBasedHeadline(lang, context as ISignupContext)}
        </h1>
      </div>
      <div className="page__content__block">
        <ul className="navigation-list links--plain">
          {
            (context?.assignRoles || []).length > 0 && (
              <li className="navigation-list__item">
                <h2 className="navigation-list__item-header">{translations.loginHeaderExisting}</h2>
                <div className="button-container links--plain vertical-spacing-top">
                  <Link className="button" to={`/${lang}/create-account/ldap?context=${context?.key}`}>{translations.loginUsingAu}</Link>
                </div>
              </li>
            )
          }
          <li className="navigation-list__item">
            <h2 className="navigation-list__item-header">{(context?.assignRoles || []).length > 0 ? translations.loginHeaderNew : translations.loginHeaderNew2}</h2>
            <p className="text--small vertical-spacing-top vertical-spacing-bottom vertical-spacing-bottom--small">
              {translations.loginCPRYes}
            </p>
            <div className="button-container links--plain">
              <a className="button" href={`/${lang}/create-account/cpr?context=${context?.key}`}>{translations.loginUsingCpr}</a>
            </div>
            <p className="text--small vertical-spacing-top vertical-spacing-bottom vertical-spacing-bottom--small">
              {translations.loginCPRNo}
            </p>
            <div className="button-container links--plain">
              <Link className="button" to={`/${lang}/create-account/form?context=${context?.key}`}>{translations.loginUsingForm}</Link>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

SelfServiceFrontComponent.displayName = 'SelfServiceFrontComponent';
export default SelfServiceFrontComponent;
